import ApiRequestService from './../ApiRequestService';
export default class WpService {
    private ApiRequest = new ApiRequestService;
    
    public GetPosts(Route: string): any {
        this.ApiRequest = new ApiRequestService();
        
        return this.ApiRequest.Get(Route);        
    }
}